import { render, staticRenderFns } from "./HrTrainAttend.vue?vue&type=template&id=6112654b&scoped=true&"
import script from "./HrTrainAttend.vue?vue&type=script&lang=js&"
export * from "./HrTrainAttend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6112654b",
  null
  
)

export default component.exports